<template>
  <v-toolbar color="white" dark elevation="0" class="app-toolbar">
    <v-app-bar-nav-icon>
      <v-btn
        :elevation="0"
        color="white"
        class="text-none"
        @click.stop="handleDrawerToggle"
      >
        <v-badge
          v-if="table.notSincronized.viagens.itens.length > 0"
          color="error"
          dot
        >
          <v-icon color="primary"> menu </v-icon>
        </v-badge>
        <v-icon v-else color="primary"> menu </v-icon>
      </v-btn>
    </v-app-bar-nav-icon>
    <!-- color="primary"
      @click.stop="handleDrawerToggle"
    />  -->
    <v-toolbar-title class="app-toolbar-title">
      {{ app_name }}
    </v-toolbar-title>
    <router-link
      to="/"
      title="ARCE - Agência Reguladora do Estado do Ceará"
      class="app-logo"
    >
      <img
        src="https://cdn.arce.ce.gov.br/logo.svg"
        height="auto"
        width="85"
        class="mat-toolbar__img"
        alt="Logo ARCE"
      />
    </router-link>
    <!-- <app-menu /> -->
  </v-toolbar>
</template>

<script>
import Vue from "vue";
import AppMenu from "./AppMenu";
import GlobalStore from "@/store/modules/global";
import { APP_NAME } from "@/commons/config";
import { mapState, mapActions } from "vuex";

export default Vue.extend({
  name: "AppToolbar",
  components: {
    AppMenu,
  },
  data: () => ({ app_name: APP_NAME }),
  computed: {
    ...mapState("viagens", ["table"]),
  },
  methods: {
    handleDrawerToggle() {
      GlobalStore.toggleDrawer();
    },
  },
});
</script>
